/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {transferFunds} from '../api'

export const useMutationTransferFunds = createReactQueryMutationHook('transferFunds', transferFunds)
